import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import useAccordionBusinessGroupsStyles from './AccordionBusinessGroups.styles';
import { IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useState } from 'react';
import EditGroup from '../EditGroup/EditGroup';
import { Grupos } from '@features/customers/interfaces/businessGroups.interfaces';
import { FiltersNoResults } from '@features/filters';
interface props {
	data: Grupos[];
	getGroups: () => Promise<void>;
	filter: boolean;
}
const AccordionBusinessGroups: React.FC<props> = ({ data, getGroups, filter }) => {
	const classes = useAccordionBusinessGroupsStyles();
	const [expanded, setExpanded] = useState<string | false>(false);
	const [openEditGroup, setOpenEditGroup] = useState(false);
	const [dataEdit, setDataEdit] = useState<Grupos | null>(null);
	const handleClickOpen = () => {
		setOpenEditGroup(true);
	};

	const handleClose = () => {
		setOpenEditGroup(false);
		setDataEdit(null);
		getGroups();
	};

	const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
		setExpanded(isExpanded ? panel : false);
	};

	return (
		<div className={classes.root}>
			{data.length > 0 ? (
				data.map((group, key) => {
					return (
						<Accordion
							disableGutters
							sx={{ position: 'initial', boxShadow: 'none' }}
							key={`accordion_group_${key}`}
							className={classes.accordion}
							expanded={group.open ? true : expanded === `accordion_group_${key}`}
							onChange={handleChange(`accordion_group_${key}`)}
						>
							<div>
								<AccordionSummary
									className={
										group.open
											? classes.accordionSummaryOpen
											: expanded === `accordion_group_${key}`
											? classes.accordionSummaryOpen
											: classes.accordionSummary
									}
									expandIcon={<ExpandMoreIcon className={classes.icon} />}
									aria-controls="panel1a-content"
									id={`accordion_group_panel_${key}`}
								>
									<Typography className={classes.title}>
										{group.descripcion}
									</Typography>
								</AccordionSummary>
								<div className={classes.buttonEdit}>
									<Tooltip
										classes={{
											tooltip: classes.tooltip,
											arrow: classes.arrow,
										}}
										style={{
											color: '#003C82',
											marginBottom: '2%',
											marginTop: '6%',
											marginLeft: 15,
										}}
										title="Editar grupo"
									>
										<IconButton
											onClick={() => {
												setDataEdit(group);
												handleClickOpen();
											}}
											style={{ float: 'right' }}
										>
											<EditIcon style={{ color: '#1063AC' }}></EditIcon>
										</IconButton>
									</Tooltip>
								</div>
							</div>
							<AccordionDetails
								style={{
									background: 'rgb(250, 250, 250)',
								}}
								sx={{
									borderBottomLeftRadius: '17px !important',
									borderBottomRightRadius: '17px !important',
								}}
							>
								<div className={classes.rootTable}>
									<table className={classes.table}>
										<thead>
											<tr>
												<th style={{ width: 200 }} className={classes.th}>
													N° Identificación
												</th>
												<th className={classes.th}>Razón social</th>
											</tr>
										</thead>
										<tbody>
											{group.clientes_grupo.map((customer, key) => {
												return (
													<tr
														style={{
															borderBottom:
																key ===
																group.clientes_grupo.length - 1
																	? '0px'
																	: '1px solid #00000029',
															background: customer.background
																? 'rgb(0 173 238 / 14%)'
																: 'transparent',
														}}
														className={
															customer.background ? 'searched' : ''
														}
														key={key}
													>
														<td className={classes.td}>
															{customer.identificacion_cliente}
														</td>
														<td className={classes.td}>
															{customer.nombre}
														</td>
													</tr>
												);
											})}
										</tbody>
									</table>
								</div>
							</AccordionDetails>
						</Accordion>
					);
				})
			) : filter ? (
				<div style={{ marginTop: 100 }}>
					<FiltersNoResults height={'auto'} />
				</div>
			) : null}
			<div>
				{openEditGroup ? (
					<EditGroup data={dataEdit} handleClose={handleClose} open={openEditGroup} />
				) : null}
			</div>
		</div>
	);
};
export default AccordionBusinessGroups;
